module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"views":{"products":{"show":{"meta_tags":{"description":"All important fund information on %{name} (%{isin}|%{wkn})","title":"%{name} | %{wkn} | %{isin}"}}}}}}}')
  delete Component.options._Ctor
}
